import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../../common/helpers/helpers";

const KeggLink = ({ geneSymbol }) => {
  return (
    <a
      href={getVarsoUrl(
        `http://www.kegg.jp/kegg-bin/search_pathway_text?map=map&keyword=${geneSymbol}&mode=1&viewImage=true`
      )}
      target="_blank"
      className="varsome-gene-link"
    >
      KEGG Pathway
    </a>
  );
};

KeggLink.propTypes = {
  geneSymbol: PropTypes.string,
};

KeggLink.defaultProps = {
  geneSymbol: null,
};

export default KeggLink;
